import { Check, Close, Info, ManageAccounts, Sync } from "@mui/icons-material";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import {
    Device_Service,
    Device_Status,
    IDevice_Row,
} from "../../services/device/device-service";
import { useEffect, useState } from "react";
import { INITIAL_FEEDBACK } from "../../utils/constants";

type Props = { device: IDevice_Row; org_code: string };

export default function Sync_Device_Users({ device, org_code }: Props) {
    const [feedback, set_feedback] = useState({
        ...INITIAL_FEEDBACK,
        severity: "",
    });

    async function handle_sync_device() {
        if (feedback.loading) {
            return;
        }

        set_feedback((curr) => ({ ...curr, loading: true }));

        const [data, error] = await Device_Service.sync_device(
            device.serial,
            org_code
        );

        if (error) {
            set_feedback({
                loading: false,
                show: true,
                message: { title: error.message },
                severity: "error",
            });
            return;
        }

        if (data) {
            set_feedback({
                loading: false,
                show: true,
                message: { title: data.message },
                severity: "success",
            });
        }
    }

    return (
        <Tooltip
            title={
                feedback.loading
                    ? "Syncing device..."
                    : feedback.message.title || "Sync Device Users"
            }
        >
            <IconButton
                color={
                    ["error", "success"].includes(feedback.severity)
                        ? (feedback.severity as any)
                        : undefined
                }
                onClick={handle_sync_device}
                size="small"
                disabled={
                    // device.status === Device_Status["In-Active"] ||
                    feedback.loading
                }
            >
                {feedback.loading ? (
                    <CircularProgress size={20} />
                ) : feedback.severity === "success" ? (
                    <Check />
                ) : feedback.severity == "error" ? (
                    <Close />
                ) : (
                    <ManageAccounts />
                )}
            </IconButton>
        </Tooltip>
    );
}
